import * as types from './types';

const initialState = {
  current: null,
  all: null,
  isLoaded: false,
  members: [],
  activeTeamMember: {},
  isActiveTeamMemberEmailVerified: null,
  isEmailResendFetching: false,
  isCreatingTeamMember: false,
  teamMembers: [],
};

export default function supplier(state = initialState, action) {
  const { payload } = action;

  switch (action.type) {
    case types.FETCH_REQUEST:
      return { ...initialState, isLoaded: false };

    case types.FETCH_SUCCESS:
      return { ...state, current: payload, isLoaded: true };

    case types.FETCH_MEMBERS_SUCCESS:
      return { ...state, members: payload || [] };

    case types.FETCH_MEMBERS_ERROR:
      return { ...state, members: [] };

    case types.RESET:
      return initialState;

    case types.GET_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        activeTeamMember: payload.teamMember,
      };

    case types.GET_TEAM_MEMBER_ERROR:
    case types.CREATE_TEAM_MEMBER:
      return {
        ...state,
        isActiveTeamMemberEmailVerified: false,
        activeTeamMember: {},
      };

    case types.GET_TEAM_MEMBERS_SUCCESS:
      return {
        ...state,
        teamMembers: payload.teamMembers,
      };

    case types.GET_TEAM_MEMBERS_ERROR:
      return {
        ...state,
        teamMembers: [],
      };

    case types.UPDATE_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        activeTeamMember: payload.teamMember,
      };
    case types.DELETE_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        teamMembers: (state.teamMembers || []).filter(
          (member) => member.id !== payload.teamMemberId,
        ),
      };
    case types.SEND_VERIFICATION_EMAIL_REQUEST:
      return {
        ...state,
        isEmailResendFetching: true,
      };
    case types.SEND_VERIFICATION_EMAIL_SUCCESS:
    case types.SEND_VERIFICATION_EMAIL_ERROR:
      return {
        ...state,
        isEmailResendFetching: false,
      };
    case types.CHECK_EMAIL_VERIFICATION_REQUEST:
      return {
        ...state,
        isActiveTeamMemberEmailVerified: null,
      };
    case types.CHECK_EMAIL_VERIFICATION_SUCCESS:
      return {
        ...state,
        isActiveTeamMemberEmailVerified: payload.isVerified,
      };
    case types.CHECK_EMAIL_VERIFICATION_ERROR:
      return {
        ...state,
        isActiveTeamMemberEmailVerified: false,
      };
    case types.CREATE_TEAM_MEMBER_REQUEST:
      return {
        ...state,
        isCreatingTeamMember: true,
      };
    case types.CREATE_TEAM_MEMBER_SUCCESS:
    case types.CREATE_TEAM_MEMBER_ERROR:
      return {
        ...state,
        isCreatingTeamMember: false,
      };
    case types.DISABLE_TEAM_MEMBER_AUTH_SUCCESS:
      return {
        ...state,
        activeTeamMember: payload.teamMember,
      };
    default:
      return state;
  }
}
